import axios from './axios'

export const insert_user = async (data) => {
  try{
    var data = JSON.stringify(data);

    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/users`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const delete_user = async (guid) => {
  try{
    var config = {
      method: 'delete',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/users/${guid}`,
      headers: { 
        'Content-Type': 'application/json'
      }
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_users = async (filter, limit, skip) => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/users`
  if(filter || limit || skip)
    url += `?`
  if(filter){
    for (const key in filter) {
      url += `&filter=AND(${key}:${filter[key]})`
    }
  }

  if(skip)
    url += `&skip=${skip}`
  if(limit)
    url += `&limit=${limit}`
  var config = {
    method: 'get',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_me = async () => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/users/me`
    
  var config = {
    method: 'get',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_user = async (guid) => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/users/${guid}`
    
  var config = {
    method: 'get',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const update_me = async (data) => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/users/me`
  var data = JSON.stringify(data);
    
  var config = {
    method: 'post',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    },
    data: data
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}